import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import  ProfilePix from './ProfilePix';
import "../../component/css/support.css";
import { ProfilePix } from "../support/ProfilePix";
import report from "../../component/images/reportflag.png";
import sendicon from "../../component/images/sendicon.png";
import attachfileicon from "../../component/images/attachfileicon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import placeholder_image from "../../component/images/aang.jpg";
import { ClipLoader } from "react-spinners";
import { TokenContext } from "../../component/token_context";
import dayjs from "dayjs";
import {
  collection,
  query,
  where,
  onSnapshot,
  getDoc,
  doc,
  getDocs,
  QuerySnapshot,
  setDoc,
  orderBy,
} from "firebase/firestore";
import { db, storage, serverTimestamp } from "../../utils/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import audioFile from "../../audio/new_noti.wav";
import audioFile2 from "../../audio/beep2.wav";
const audio = new Audio(audioFile);

// flies for audio when sending a message
const audio2 = new Audio(audioFile2);

export default function Message_Fleet_Manager() {
  const value = useContext(TokenContext);
  const { setNewMsg } = value;
  const admin_id = JSON.parse(sessionStorage.getItem("admin_id"));
  const admin_name = JSON.parse(sessionStorage.getItem("admin_name"));
  let admin_img = sessionStorage.getItem("admin_img");
  if (admin_img == undefined) {
    admin_img = "a";
  }
  const token = JSON.parse(sessionStorage.getItem("userToken"));
  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [result, setResult] = useState("");
  const [conv_id, setConvId] = useState("");
  const [result2, setResult2] = useState("");
  const [data2, setData2] = useState([]);
  const [firstFire, setFirstFire] = useState(true);
  const [count, setCount] = useState(0);
  // const [profile_pic, setProfilePic] = useState('');
  // const [sender_name, setSenderName] = useState('');
  const [content, setContent] = useState("");
  const location = useLocation();

  const [img, setImg] = useState("");
  const [display, setDisplay] = useState("");
  const [loading, setLoading] = useState(false);

  //console.log(location);
  const receiver_id = location.state.details.id;
  const sender_name = location.state.details.fullname;
  const profile_pic = location.state.details.img;
  const email = location.state.details.email;
  const [new_conv, setNewConv] = useState(false);
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);

  const Messager = (item, i) => {
    const admin_id = JSON.parse(sessionStorage.getItem("admin_id"));
    const DateConverter = (props) => {
      const timer = item?.timestamp
        ? dayjs(props.value.seconds * 1000).format("MMM DD, YYYY")
        : "...";
      return timer;
    };

    const TimeConverter = (props) => {
      //console.log(item);
      const timer = item?.timestamp
        ? dayjs(props.value.seconds * 1000).format("hh:mm a")
        : "...";
      return timer;
    };
    let cname = "";
    if (item.sender_id !== receiver_id) {
      cname = "outgoing-msgs";
    } else {
      cname = "incoming-msgs";
    }
    return (
      <div
        className={
          cname === "outgoing-msgs"
            ? "shadow-outgoing-msg-container"
            : "shadow-incoming-msg-container"
        }
        ref={messagesEndRef}
        key={i}
      >
        <div
          className={
            cname === "outgoing-msgs"
              ? "shadow-outgoing-msg-wrapper"
              : "shadow-incoming-msg-wrapper"
          }
        >
          {/* <p className="date-of-msg"> */}

          <div className={cname}>
            <p>{item?.content}</p>
          </div>
          <p
            className={
              cname === "outgoing-msgs" ? "date-of-msg" : "shadow-date-of-msg"
            }
          >
            <TimeConverter value={item?.timestamp} /> <br />
            <DateConverter value={item?.timestamp} />
          </p>
        </div>
      </div>
    );
  };

  useEffect(() => {
    CheckConvers();
  }, [isLoaded === false]);

  // useEffect(() => {
  //     GetMessages();
  // }, [conv_id]);

  useEffect(() => {
    const q = query(
      collection(db, "hf_collection", conv_id, conv_id),
      orderBy("timestamp", "asc")
    );
    const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
      const list = [];
      QuerySnapshot.forEach((doc) => {
        list.push(doc?.data());
        //console.log(doc.data());
        setData2(list);
        //console.log("got here");
        //console.log('exciting times');
        // setMessageList(messageList);
        //console.log(list.length);
      });
    });
    if (isLoaded === false) {
      unsubscribe();
    }
    let countM = {};
    const check = onSnapshot(
      doc(db, "admin_notifiers", "hf_messages"),
      async (doc) => {
        countM = doc.data();
        if (firstFire == true) {
          setCount(countM.messages_count);
          setFirstFire(false);
        } else {
          if (countM.messages_count !== count) {
            setCount(countM.messages_count);
            audio.play();
            setNewMsg(true);
          }
        }
      }
    );
  }, [isLoaded === false, conv_id]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    // setNewMsg(false);
  }, [data2]);

  const CheckConvers = async () => {
    // setNewMsg(false);
    try {
      //console.log(receiver_id);
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/help_feedback_admin/check_convers",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            receiver_id: receiver_id,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      // getData(await response.json());
      const resultM = await response.json();
      //console.log(resultM);
      setIsLoaded(true);
      if (resultM.msg === "Success") {
        setConvId(resultM.conversation_id);
        setIsLoaded(true);
        setNewConv(false);
      } else if (resultM.msg === "No conversation found") {
        setIsLoaded(true);
        // setConvId("a");
        setNewConv(true);
        // setIsLoaded(true);
      }

      if (response.status === 200) {
        //console.log("data gotten succesfully");
        setResult(resultM);
      } else {
        //console.log("some error occurred");
      }
    } catch (error) {
      //console.log(error);
    }
  };

  // const GetMessages = async () => {
  //   try {
  //       //console.log(conv_id);
  //       const response = await fetch(
  //           "https://serverpickload.wl.r.appspot.com/delivery_agent_chat/get_messages",
  //           {
  //             method: "POST",

  //             body: JSON.stringify({
  //               token: token,
  //               conv_id: conv_id,
  //               pagec: 1
  //             }),
  //             headers: {
  //               "Content-Type": "application/json",
  //               Accept: "application/json, text/plain, */*"
  //             },
  //           }
  //       )
  //       // getData(await response.json());
  //       const resultM = await response.json();
  //       //console.log(resultM)
  //       setData2(resultM.messages);
  //       setResult2(resultM)
  //       //console.log(resultM.messages);
  //       //console.log(data2);
  //       // setSenderName(resultM.latest_message.sender_name);

  //       if(response.status === 200) {
  //           //console.log('data gotten succesfully')
  //           //console.log(data2);
  //       } else {
  //           //console.log('some error occurred')
  //       }
  //   } catch(error) {
  //       //console.log(error);
  //   }
  // }

  const SendMessage = async (e) => {
    e.preventDefault();
    if (new_conv === true) {
      const contentToDB = content;
      setContent("");
      let url;
      if (img) {
        const imageRef = ref(
          storage,
          `messageAttachment/${new Date().getTime()}-${img.name}`
        );
        const snap = await uploadBytes(imageRef, img);
        const durl = await getDownloadURL(ref(storage, snap.ref.fullPath));
        url = durl;
      }

      try {
        const res = await fetch(
          "https://serverpickload.wl.r.appspot.com/help_feedback/send_message",
          {
            method: "POST",
            body: JSON.stringify({
              token: token,
              // receiver_id: receiver_id,
              sender_name: admin_name,
              new_conv: true,
              sender_img: admin_img || "a",
              content: contentToDB ? contentToDB : url,
              who_sent: "admin",
              which_user: "delivery_agent",
              user_id: receiver_id,
              message_type: img ? "image" : "text",
            }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json, text/plain, */*",
            },
          }
        );
        const resultM = await res.json();
        //console.log(resultM);
        const timestamp = Date.now();

        if (res.status === 200) {
          setConvId(resultM?.message.conversation_id);
          setNewConv(false);
          //console.log(resultM?.message.conversation_id);
          //console.log("hello world");
          //console.log(resultM);
          //console.log(conv_id);
          // moved the firebase message so when it is successful it will send to firebase so it has to wait for the convId
          //console.log(data2);
          const sent = await setDoc(
            doc(
              db,
              "hf_collection",
              resultM?.message.conversation_id,
              resultM?.message.conversation_id,
              `${timestamp}`
            ),
            {
              content: contentToDB ? contentToDB : url,
              conv_id: resultM?.message.conversation_id,
              receiver_id: receiver_id,
              sender_id: admin_id,
              sender_img: admin_img || "a",
              sender_name: admin_name,
              timestamp: serverTimestamp(),
              file_name: contentToDB ? "a" : "IMG_" + timestamp,
              who_sent: "admin",
              which_user: "delivery_agent",
              user_id: receiver_id,
              message_type: img ? "image" : "text",
            }
          );

          if (sent) {
            setContent("");
          }
          audio2.play();

          // // update the messages count field
          // await setDoc(
          //   doc(
          //     db,
          //     "hf_collection",
          //     "statistics"
          //   ),
          //   {messages_count: count + 1}
          // );
        }
      } catch (error) {
        //console.log(error);
        // const err = error
      }
      setImg("");
      setDisplay("");
    } else {
      if (e.keyCode === 13 && e.shiftKey === false) {
        const contentToDB = content;
        setContent("");
        let url;
        if (img) {
          const imageRef = ref(
            storage,
            `messageAttachment/${new Date().getTime()}-${img.name}`
          );
          const snap = await uploadBytes(imageRef, img);
          const durl = await getDownloadURL(ref(storage, snap.ref.fullPath));
          url = durl;
        }

        //console.log("I am here");
        //console.log(conv_id);
        // const timestamp = Date.now()
        const timestamp = Date.now();
        const sent = await setDoc(
          doc(db, "hf_collection", conv_id, conv_id, `${timestamp}`),
          {
            content: contentToDB ? contentToDB : url,
            conv_id: conv_id,
            receiver_id: receiver_id,
            sender_id: admin_id,
            sender_img: admin_img || "a",
            sender_name: admin_name,
            timestamp: serverTimestamp(),
            file_name: contentToDB ? "a" : "IMG_" + timestamp,
            who_sent: "admin",
            which_user: "delivery_agent",
            user_id: receiver_id,
            message_type: img ? "image" : "text",
          }
        );
        if (sent) {
          setContent("");
        }
        audio2.play();

        // // update the messages count field
        // await setDoc(
        //   doc(
        //     db,
        //     "hf_collection",
        //     "statistics"
        //   ),
        //   {messages_count: count + 1}
        // );

        await fetch(
          "https://serverpickload.wl.r.appspot.com/help_feedback/send_message",
          {
            method: "POST",
            body: JSON.stringify({
              token: token,
              receiver_id: receiver_id,
              sender_name: admin_name,
              new_conv: false,
              sender_img: admin_img || "a",
              content: contentToDB ? contentToDB : img.name,
              who_sent: "admin",
              which_user: "delivery_agent",
              conv_id: conv_id,
              user_id: receiver_id,
              message_type: img ? "image" : "text",
            }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json, text/plain, */*",
            },
          }
        );
        setImg("");
        setDisplay("");
      } else if (!e.code) {
        const contentToDB = content;
        setContent("");
        setLoading(true);

        let url;
        if (img) {
          const imageRef = ref(
            storage,
            `messageAttachment/${new Date().getTime()}-${img.name}`
          );
          const snap = await uploadBytes(imageRef, img);
          const durl = await getDownloadURL(ref(storage, snap.ref.fullPath));
          url = durl;
        }

        //console.log("I am here");
        //console.log(conv_id);
        // const timestamp = Date.now()
        const timestamp = Date.now();
        const sent = await setDoc(
          doc(db, "hf_collection", conv_id, conv_id, `${timestamp}`),
          {
            content: contentToDB ? contentToDB : url,
            conv_id: conv_id,
            receiver_id: receiver_id,
            sender_id: admin_id,
            sender_img: admin_img || "a",
            sender_name: admin_name,
            timestamp: serverTimestamp(),
            file_name: contentToDB ? "a" : "IMG_" + timestamp,
            who_sent: "admin",
            which_user: "delivery_agent",
            user_id: receiver_id,
            message_type: img ? "image" : "text",
          }
        );
        if (sent) {
          setContent("");
        }
        audio2.play();

        // // update the messages count field
        // await setDoc(
        //   doc(
        //     db,
        //     "hf_collection",
        //     "statistics"
        //   ),
        //   {messages_count: count + 1}
        // );

        await fetch(
          "https://serverpickload.wl.r.appspot.com/help_feedback/send_message",
          {
            method: "POST",
            body: JSON.stringify({
              token: token,
              receiver_id: receiver_id,
              sender_name: admin_name,
              new_conv: false,
              sender_img: admin_img || "a",
              content: contentToDB ? contentToDB : img.name,
              who_sent: "admin",
              which_user: "delivery_agent",
              conv_id: conv_id,
              user_id: receiver_id,
              message_type: img ? "image" : "text",
            }),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json, text/plain, */*",
            },
          }
        );
        setImg("");
        setDisplay("");
        setLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    setImg(e.target.files[0]);
    setDisplay(URL.createObjectURL(e.target.files[0]));
  };

  if (!isLoaded) {
    //console.log("got here");
    return (
      <h1 className="loading-pages1">
        <ClipLoader color={"#1FAA08"} size={100} />
      </h1>
    );
  } else if (conv_id?.length > 0) {
    //console.log(conv_id);
    return (
      <div className="support-chat">
        <div className="chat-wrapper">
          <div className="back2">
            <span>
              <FontAwesomeIcon
                icon={faArrowLeftLong}
                onClick={() => navigate(-1)}
                className="back"
              ></FontAwesomeIcon>{" "}
            </span>{" "}
            <br />
          </div>
          <div className="chat-right-side">
            {display && (
              <span className="photo_display">
                {display && <img src={display} width="100%" height="100%" />}{" "}
              </span>
            )}
            <div className="shadow-chat-right-side-wrapper">
              <div className="main-chat-discussion">
                <div className="profile-picture1">
                  <img
                    src={profile_pic ? profile_pic : placeholder_image}
                    alt="icon"
                    className="support-profile-pic1"
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <div className="your-profile">
                  <h3>{sender_name}</h3>
                  <h6 style={{ paddingTop: "6px" }}>{email}</h6>
                </div>
              </div>
              <div className="message-header">
                <h6>Conversations</h6>
              </div>

              <div className="messages-wrapper">
                {data2?.map((item, i) => Messager(item, i))}
                <div ref={messagesEndRef} />
                <div className="shadow-chat-section">
                  <form
                    onSubmit={SendMessage}
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <div className="typing-bar">
                      <textarea
                        disabled={img}
                        role="textbox"
                        placeholder="Type your message..."
                        className="shadow-text-area"
                        rows="1"
                        cols="20"
                        typeof="submit"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        onKeyUp={SendMessage}
                      ></textarea>
                    </div>
                    <div className="chat-icons">
                      <label
                        htmlFor="img"
                        className="shadow-label-text"
                        id={content ? "disabled" : ""}
                      >
                        <img src={attachfileicon} width="30px" height="30px" />
                      </label>
                      <input
                        type="file"
                        name="img"
                        id="img"
                        accept="image/*"
                        onChange={handleChange}
                        style={{ display: "none" }}
                        disabled={content}
                      />

                      <div className="send-message">
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            width: "45px",
                          }}
                          disabled={loading}
                          id={!content && !img ? "disabled" : ""}
                        >
                          <img src={sendicon} onClick={SendMessage} />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (conv_id === "") {
    return (
      <div className="support-chat">
        <div className="chat-wrapper">
          <div className="back2">
            <span>
              <FontAwesomeIcon
                icon={faArrowLeftLong}
                onClick={() => navigate(-1)}
                className="back"
              ></FontAwesomeIcon>{" "}
            </span>{" "}
            <br />
          </div>
          <div className="chat-right-side">
            <div className="shadow-chat-right-side-wrapper">
              <div className="main-chat-discussion">
                <div className="profile-picture1">
                  <img
                    src={profile_pic ? profile_pic : placeholder_image}
                    alt="icon"
                    className="support-profile-pic1"
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <div className="your-profile">
                  <h3>{sender_name}</h3>
                  <h6>{email}</h6>
                </div>
              </div>
              <div className="message-header">
                <h6>Conversations</h6>
              </div>

              <div className="messages-wrapper">
                <div ref={messagesEndRef} />
                <div className="shadow-chat-section">
                  <div className="typing-bar">
                    <textarea
                      role="textbox"
                      placeholder="Type your message..."
                      className="shadow-text-area"
                      rows="1"
                      cols="20"
                      typeof="submit"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="chat-icons">
                    <div className="send-message">
                      <img src={sendicon} alt="" onClick={SendMessage} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
